/**
 * Onboarding Redux Action Types
 * Follows the existing Begin / Success / Err pattern used throughout the app.
 */
const actions = {
  // Session fetch (GET /api/onboarding/session)
  ONBOARDING_SESSION_BEGIN: 'ONBOARDING_SESSION_BEGIN',
  ONBOARDING_SESSION_SUCCESS: 'ONBOARDING_SESSION_SUCCESS',
  ONBOARDING_SESSION_ERR: 'ONBOARDING_SESSION_ERR',

  // Step save (POST /api/onboarding/step/:stepSlug)
  ONBOARDING_STEP_SAVE_BEGIN: 'ONBOARDING_STEP_SAVE_BEGIN',
  ONBOARDING_STEP_SAVE_SUCCESS: 'ONBOARDING_STEP_SAVE_SUCCESS',
  ONBOARDING_STEP_SAVE_ERR: 'ONBOARDING_STEP_SAVE_ERR',

  // Chat message (POST /api/onboarding/chat)
  ONBOARDING_CHAT_BEGIN: 'ONBOARDING_CHAT_BEGIN',
  ONBOARDING_CHAT_SUCCESS: 'ONBOARDING_CHAT_SUCCESS',
  ONBOARDING_CHAT_ERR: 'ONBOARDING_CHAT_ERR',

  // Initiate (POST /api/onboarding/initiate)
  ONBOARDING_INITIATE_BEGIN: 'ONBOARDING_INITIATE_BEGIN',
  ONBOARDING_INITIATE_SUCCESS: 'ONBOARDING_INITIATE_SUCCESS',
  ONBOARDING_INITIATE_ERR: 'ONBOARDING_INITIATE_ERR',

  // Verify email (POST /api/onboarding/verify-email)
  ONBOARDING_VERIFY_BEGIN: 'ONBOARDING_VERIFY_BEGIN',
  ONBOARDING_VERIFY_SUCCESS: 'ONBOARDING_VERIFY_SUCCESS',
  ONBOARDING_VERIFY_ERR: 'ONBOARDING_VERIFY_ERR',

  // Resend OTP (POST /api/onboarding/resend-otp) 
  ONBOARDING_RESEND_BEGIN: 'ONBOARDING_RESEND_BEGIN',
  ONBOARDING_RESEND_SUCCESS: 'ONBOARDING_RESEND_SUCCESS',
  ONBOARDING_RESEND_ERR: 'ONBOARDING_RESEND_ERR',

  // Complete (POST /api/onboarding/complete) 
  ONBOARDING_COMPLETE_BEGIN: 'ONBOARDING_COMPLETE_BEGIN',
  ONBOARDING_COMPLETE_SUCCESS: 'ONBOARDING_COMPLETE_SUCCESS',
  ONBOARDING_COMPLETE_ERR: 'ONBOARDING_COMPLETE_ERR',

  // PMS list fetch (GET /api/onboarding/pms-list)
  ONBOARDING_PMS_LIST_BEGIN: 'ONBOARDING_PMS_LIST_BEGIN',
  ONBOARDING_PMS_LIST_SUCCESS: 'ONBOARDING_PMS_LIST_SUCCESS',
  ONBOARDING_PMS_LIST_ERR: 'ONBOARDING_PMS_LIST_ERR',

  // PMS OAuth initiate (POST /api/onboarding/initiate-pms-auth)
  ONBOARDING_PMS_AUTH_BEGIN: 'ONBOARDING_PMS_AUTH_BEGIN',
  ONBOARDING_PMS_AUTH_SUCCESS: 'ONBOARDING_PMS_AUTH_SUCCESS',
  ONBOARDING_PMS_AUTH_ERR: 'ONBOARDING_PMS_AUTH_ERR',

  // Message templates fetch (GET /api/onboarding/message-templates)
  ONBOARDING_MSG_TEMPLATES_BEGIN: 'ONBOARDING_MSG_TEMPLATES_BEGIN',
  ONBOARDING_MSG_TEMPLATES_SUCCESS: 'ONBOARDING_MSG_TEMPLATES_SUCCESS',
  ONBOARDING_MSG_TEMPLATES_ERR: 'ONBOARDING_MSG_TEMPLATES_ERR',

  // Qualify (POST /api/onboarding/qualify)
  ONBOARDING_QUALIFY_BEGIN: 'ONBOARDING_QUALIFY_BEGIN',
  ONBOARDING_QUALIFY_SUCCESS: 'ONBOARDING_QUALIFY_SUCCESS',
  ONBOARDING_QUALIFY_ERR: 'ONBOARDING_QUALIFY_ERR',

  // Stripe SetupIntent (POST /api/onboarding/stripe/setup-intent)
  ONBOARDING_STRIPE_SETUP_BEGIN: 'ONBOARDING_STRIPE_SETUP_BEGIN',
  ONBOARDING_STRIPE_SETUP_SUCCESS: 'ONBOARDING_STRIPE_SETUP_SUCCESS',
  ONBOARDING_STRIPE_SETUP_ERR: 'ONBOARDING_STRIPE_SETUP_ERR',

  // Stripe confirm PM (POST /api/onboarding/stripe/confirm-payment-method)
  ONBOARDING_STRIPE_CONFIRM_BEGIN: 'ONBOARDING_STRIPE_CONFIRM_BEGIN',
  ONBOARDING_STRIPE_CONFIRM_SUCCESS: 'ONBOARDING_STRIPE_CONFIRM_SUCCESS',
  ONBOARDING_STRIPE_CONFIRM_ERR: 'ONBOARDING_STRIPE_CONFIRM_ERR',

  // Agree-defaults fetch (GET /api/onboarding/agree-defaults)
  ONBOARDING_AGREE_DEFAULTS_BEGIN:   'ONBOARDING_AGREE_DEFAULTS_BEGIN',
  ONBOARDING_AGREE_DEFAULTS_SUCCESS: 'ONBOARDING_AGREE_DEFAULTS_SUCCESS',
  ONBOARDING_AGREE_DEFAULTS_ERR:     'ONBOARDING_AGREE_DEFAULTS_ERR',

  // Partner coverage fetch (GET /api/onboarding/partner-coverage) 
  ONBOARDING_PARTNER_COVERAGE_BEGIN:   'ONBOARDING_PARTNER_COVERAGE_BEGIN',
  ONBOARDING_PARTNER_COVERAGE_SUCCESS: 'ONBOARDING_PARTNER_COVERAGE_SUCCESS',
  ONBOARDING_PARTNER_COVERAGE_ERR:     'ONBOARDING_PARTNER_COVERAGE_ERR',

  // Listings sync-progress poll (GET /api/onboarding/listings-sync-progress)
  ONBOARDING_SYNC_PROGRESS_BEGIN:   'ONBOARDING_SYNC_PROGRESS_BEGIN',
  ONBOARDING_SYNC_PROGRESS_SUCCESS: 'ONBOARDING_SYNC_PROGRESS_SUCCESS',
  ONBOARDING_SYNC_PROGRESS_ERR:     'ONBOARDING_SYNC_PROGRESS_ERR',

  // Local fave add (POST /api/onboarding/listings/:slug/locals) 
  ONBOARDING_LOCAL_FAVE_ADD_BEGIN:   'ONBOARDING_LOCAL_FAVE_ADD_BEGIN',
  ONBOARDING_LOCAL_FAVE_ADD_SUCCESS: 'ONBOARDING_LOCAL_FAVE_ADD_SUCCESS',
  ONBOARDING_LOCAL_FAVE_ADD_ERR:     'ONBOARDING_LOCAL_FAVE_ADD_ERR',

  // Local fave update (PUT /api/onboarding/listings/:slug/locals/:faveSlug)
  ONBOARDING_LOCAL_FAVE_UPDATE_BEGIN:   'ONBOARDING_LOCAL_FAVE_UPDATE_BEGIN',
  ONBOARDING_LOCAL_FAVE_UPDATE_SUCCESS: 'ONBOARDING_LOCAL_FAVE_UPDATE_SUCCESS',
  ONBOARDING_LOCAL_FAVE_UPDATE_ERR:     'ONBOARDING_LOCAL_FAVE_UPDATE_ERR',

  // Local fave delete (DELETE /api/onboarding/listings/:slug/locals/:faveSlug)
  ONBOARDING_LOCAL_FAVE_DELETE_BEGIN:   'ONBOARDING_LOCAL_FAVE_DELETE_BEGIN',
  ONBOARDING_LOCAL_FAVE_DELETE_SUCCESS: 'ONBOARDING_LOCAL_FAVE_DELETE_SUCCESS',
  ONBOARDING_LOCAL_FAVE_DELETE_ERR:     'ONBOARDING_LOCAL_FAVE_DELETE_ERR',

  // Local fave reorder (POST /api/onboarding/listings/:slug/locals/reorder)
  ONBOARDING_LOCAL_FAVE_REORDER_BEGIN:   'ONBOARDING_LOCAL_FAVE_REORDER_BEGIN',
  ONBOARDING_LOCAL_FAVE_REORDER_SUCCESS: 'ONBOARDING_LOCAL_FAVE_REORDER_SUCCESS',
  ONBOARDING_LOCAL_FAVE_REORDER_ERR:     'ONBOARDING_LOCAL_FAVE_REORDER_ERR',

  // Guidebook section save (POST /api/onboarding/listings/:slug/guidebook-section)
  ONBOARDING_GUIDEBOOK_SECTION_SAVE_BEGIN:   'ONBOARDING_GUIDEBOOK_SECTION_SAVE_BEGIN',
  ONBOARDING_GUIDEBOOK_SECTION_SAVE_SUCCESS: 'ONBOARDING_GUIDEBOOK_SECTION_SAVE_SUCCESS',
  ONBOARDING_GUIDEBOOK_SECTION_SAVE_ERR:     'ONBOARDING_GUIDEBOOK_SECTION_SAVE_ERR',

  // Set listing theme (POST /api/onboarding/set-listing-theme)
  ONBOARDING_SET_LISTING_THEME_BEGIN:   'ONBOARDING_SET_LISTING_THEME_BEGIN',
  ONBOARDING_SET_LISTING_THEME_SUCCESS: 'ONBOARDING_SET_LISTING_THEME_SUCCESS',
  ONBOARDING_SET_LISTING_THEME_ERR:     'ONBOARDING_SET_LISTING_THEME_ERR',

  // Trigger listing sync (POST /api/onboarding/trigger-listing-sync)
  ONBOARDING_TRIGGER_LISTING_SYNC_BEGIN:   'ONBOARDING_TRIGGER_LISTING_SYNC_BEGIN',
  ONBOARDING_TRIGGER_LISTING_SYNC_SUCCESS: 'ONBOARDING_TRIGGER_LISTING_SYNC_SUCCESS',
  ONBOARDING_TRIGGER_LISTING_SYNC_ERR:     'ONBOARDING_TRIGGER_LISTING_SYNC_ERR',

  // Guidebook preview (GET /api/onboarding/listings/:slug/guidebook-preview)
  ONBOARDING_GUIDEBOOK_PREVIEW_BEGIN:   'ONBOARDING_GUIDEBOOK_PREVIEW_BEGIN',
  ONBOARDING_GUIDEBOOK_PREVIEW_SUCCESS: 'ONBOARDING_GUIDEBOOK_PREVIEW_SUCCESS',
  ONBOARDING_GUIDEBOOK_PREVIEW_ERR:     'ONBOARDING_GUIDEBOOK_PREVIEW_ERR',

  // Onboarding themes (GET /api/onboarding/themes)
  ONBOARDING_THEMES_BEGIN:   'ONBOARDING_THEMES_BEGIN',
  ONBOARDING_THEMES_SUCCESS: 'ONBOARDING_THEMES_SUCCESS',
  ONBOARDING_THEMES_ERR:     'ONBOARDING_THEMES_ERR',

  // Update message template (PUT /api/onboarding/message-templates/:slug)
  ONBOARDING_UPDATE_MSG_TEMPLATE_BEGIN:   'ONBOARDING_UPDATE_MSG_TEMPLATE_BEGIN',
  ONBOARDING_UPDATE_MSG_TEMPLATE_SUCCESS: 'ONBOARDING_UPDATE_MSG_TEMPLATE_SUCCESS',
  ONBOARDING_UPDATE_MSG_TEMPLATE_ERR:     'ONBOARDING_UPDATE_MSG_TEMPLATE_ERR',

  // Activate messaging (POST /api/onboarding/activate-messaging)
  ONBOARDING_ACTIVATE_MESSAGING_BEGIN:   'ONBOARDING_ACTIVATE_MESSAGING_BEGIN',
  ONBOARDING_ACTIVATE_MESSAGING_SUCCESS: 'ONBOARDING_ACTIVATE_MESSAGING_SUCCESS',
  ONBOARDING_ACTIVATE_MESSAGING_ERR:     'ONBOARDING_ACTIVATE_MESSAGING_ERR',

  // Guidebook status (GET /api/onboarding/listings/:slug/guidebook-status)
  ONBOARDING_GUIDEBOOK_STATUS_BEGIN:   'ONBOARDING_GUIDEBOOK_STATUS_BEGIN',
  ONBOARDING_GUIDEBOOK_STATUS_SUCCESS: 'ONBOARDING_GUIDEBOOK_STATUS_SUCCESS',
  ONBOARDING_GUIDEBOOK_STATUS_ERR:     'ONBOARDING_GUIDEBOOK_STATUS_ERR',

  // Persist user selections in-memory so steps restore state on back-navigation
  ONBOARDING_SET_STEP_DRAFT: 'ONBOARDING_SET_STEP_DRAFT',

  // PMS connection status (GET /api/onboarding/pms-connection-status)
  ONBOARDING_PMS_CONNECTION_STATUS_BEGIN:   'ONBOARDING_PMS_CONNECTION_STATUS_BEGIN',
  ONBOARDING_PMS_CONNECTION_STATUS_SUCCESS: 'ONBOARDING_PMS_CONNECTION_STATUS_SUCCESS',
  ONBOARDING_PMS_CONNECTION_STATUS_ERR:     'ONBOARDING_PMS_CONNECTION_STATUS_ERR',

  // Connect PMS credentials (POST /api/onboarding/connect-pms-credentials)
  ONBOARDING_CONNECT_PMS_CREDENTIALS_BEGIN:   'ONBOARDING_CONNECT_PMS_CREDENTIALS_BEGIN',
  ONBOARDING_CONNECT_PMS_CREDENTIALS_SUCCESS: 'ONBOARDING_CONNECT_PMS_CREDENTIALS_SUCCESS',
  ONBOARDING_CONNECT_PMS_CREDENTIALS_ERR:     'ONBOARDING_CONNECT_PMS_CREDENTIALS_ERR',

  // Is US host check (GET /api/onboarding/is-us-host)
  ONBOARDING_IS_US_HOST_BEGIN:   'ONBOARDING_IS_US_HOST_BEGIN',
  ONBOARDING_IS_US_HOST_SUCCESS: 'ONBOARDING_IS_US_HOST_SUCCESS',
  ONBOARDING_IS_US_HOST_ERR:     'ONBOARDING_IS_US_HOST_ERR',

  // Arrival instruction preference (POST /api/onboarding/arrival-instruction-preference)
  ONBOARDING_ARRIVAL_PREF_BEGIN:   'ONBOARDING_ARRIVAL_PREF_BEGIN',
  ONBOARDING_ARRIVAL_PREF_SUCCESS: 'ONBOARDING_ARRIVAL_PREF_SUCCESS',
  ONBOARDING_ARRIVAL_PREF_ERR:     'ONBOARDING_ARRIVAL_PREF_ERR',

  // Task verbiages (POST /api/admin/tasks/verbiages)
  ONBOARDING_TASK_VERBIAGES_BEGIN:   'ONBOARDING_TASK_VERBIAGES_BEGIN',
  ONBOARDING_TASK_VERBIAGES_SUCCESS: 'ONBOARDING_TASK_VERBIAGES_SUCCESS',
  ONBOARDING_TASK_VERBIAGES_ERR:     'ONBOARDING_TASK_VERBIAGES_ERR',

  // Complete all tasks (POST /api/onboarding/tasks/complete-all)
  ONBOARDING_TASK_COMPLETE_ALL_BEGIN:   'ONBOARDING_TASK_COMPLETE_ALL_BEGIN',
  ONBOARDING_TASK_COMPLETE_ALL_SUCCESS: 'ONBOARDING_TASK_COMPLETE_ALL_SUCCESS',
  ONBOARDING_TASK_COMPLETE_ALL_ERR:     'ONBOARDING_TASK_COMPLETE_ALL_ERR',

  // Upgrade to Pro plan
  ONBOARDING_UPGRADE_TO_PRO_BEGIN:   'ONBOARDING_UPGRADE_TO_PRO_BEGIN',
  ONBOARDING_UPGRADE_TO_PRO_SUCCESS: 'ONBOARDING_UPGRADE_TO_PRO_SUCCESS',
  ONBOARDING_UPGRADE_TO_PRO_ERR:     'ONBOARDING_UPGRADE_TO_PRO_ERR',

  // CMS pre-fetch store
  ONBOARDING_CMS_SET: 'ONBOARDING_CMS_SET',

  // Journey log batch send (POST /api/logs/log-onboarding-error)
  // Kept separate from the other Begin/Success/Err pairs above on purpose:
  // this call is fire-and-forget background telemetry, not a user-facing
  // action, so its reducer case (below) must never touch the shared
  // `loading`/`error` fields that real onboarding steps rely on.
  ONBOARDING_LOGS_BEGIN:   'ONBOARDING_LOGS_BEGIN',
  ONBOARDING_LOGS_SUCCESS: 'ONBOARDING_LOGS_SUCCESS',
  ONBOARDING_LOGS_ERR:     'ONBOARDING_LOGS_ERR',

  // Generic onboarding client action log (POST /api/log-client-error)
  // Same fire-and-forget contract as ONBOARDING_LOGS — never touches shared loading/error.
  ONBOARDING_CLIENT_LOG_BEGIN:   'ONBOARDING_CLIENT_LOG_BEGIN',
  ONBOARDING_CLIENT_LOG_SUCCESS: 'ONBOARDING_CLIENT_LOG_SUCCESS',
  ONBOARDING_CLIENT_LOG_ERR:     'ONBOARDING_CLIENT_LOG_ERR',

  // Action creators
  onboardingSessionBegin: () => ({ type: actions.ONBOARDING_SESSION_BEGIN }),
  onboardingSessionSuccess: (data) => ({ type: actions.ONBOARDING_SESSION_SUCCESS, data }),
  onboardingSessionErr: (err) => ({ type: actions.ONBOARDING_SESSION_ERR, err }),

  onboardingStepSaveBegin: () => ({ type: actions.ONBOARDING_STEP_SAVE_BEGIN }),
  onboardingStepSaveSuccess: (data) => ({ type: actions.ONBOARDING_STEP_SAVE_SUCCESS, data }),
  onboardingStepSaveErr: (err) => ({ type: actions.ONBOARDING_STEP_SAVE_ERR, err }),

  onboardingChatBegin: () => ({ type: actions.ONBOARDING_CHAT_BEGIN }),
  onboardingChatSuccess: (data) => ({ type: actions.ONBOARDING_CHAT_SUCCESS, data }),
  onboardingChatErr: (err) => ({ type: actions.ONBOARDING_CHAT_ERR, err }),

  onboardingInitiateBegin: () => ({ type: actions.ONBOARDING_INITIATE_BEGIN }),
  onboardingInitiateSuccess: (data) => ({ type: actions.ONBOARDING_INITIATE_SUCCESS, data }),
  onboardingInitiateErr: (err) => ({ type: actions.ONBOARDING_INITIATE_ERR, err }),

  onboardingVerifyBegin: () => ({ type: actions.ONBOARDING_VERIFY_BEGIN }),
  onboardingVerifySuccess: (data) => ({ type: actions.ONBOARDING_VERIFY_SUCCESS, data }),
  onboardingVerifyErr: (err) => ({ type: actions.ONBOARDING_VERIFY_ERR, err }),

  onboardingResendBegin: () => ({ type: actions.ONBOARDING_RESEND_BEGIN }),
  onboardingResendSuccess: (data) => ({ type: actions.ONBOARDING_RESEND_SUCCESS, data }),
  onboardingResendErr: (err) => ({ type: actions.ONBOARDING_RESEND_ERR, err }),

  onboardingCompleteBegin: () => ({ type: actions.ONBOARDING_COMPLETE_BEGIN }),
  onboardingCompleteSuccess: (data) => ({ type: actions.ONBOARDING_COMPLETE_SUCCESS, data }),
  onboardingCompleteErr: (err) => ({ type: actions.ONBOARDING_COMPLETE_ERR, err }),

  onboardingPmsListBegin: () => ({ type: actions.ONBOARDING_PMS_LIST_BEGIN }),
  onboardingPmsListSuccess: (data) => ({ type: actions.ONBOARDING_PMS_LIST_SUCCESS, data }),
  onboardingPmsListErr: (err) => ({ type: actions.ONBOARDING_PMS_LIST_ERR, err }),

  onboardingPmsAuthBegin: () => ({ type: actions.ONBOARDING_PMS_AUTH_BEGIN }),
  onboardingPmsAuthSuccess: (data) => ({ type: actions.ONBOARDING_PMS_AUTH_SUCCESS, data }),
  onboardingPmsAuthErr: (err) => ({ type: actions.ONBOARDING_PMS_AUTH_ERR, err }),

  onboardingMsgTemplatesBegin: () => ({ type: actions.ONBOARDING_MSG_TEMPLATES_BEGIN }),
  onboardingMsgTemplatesSuccess: (data) => ({ type: actions.ONBOARDING_MSG_TEMPLATES_SUCCESS, data }),
  onboardingMsgTemplatesErr: (err) => ({ type: actions.ONBOARDING_MSG_TEMPLATES_ERR, err }),

  onboardingQualifyBegin: () => ({ type: actions.ONBOARDING_QUALIFY_BEGIN }),
  onboardingQualifySuccess: (data) => ({ type: actions.ONBOARDING_QUALIFY_SUCCESS, data }),
  onboardingQualifyErr: (err) => ({ type: actions.ONBOARDING_QUALIFY_ERR, err }),

  onboardingStripeSetupBegin: () => ({ type: actions.ONBOARDING_STRIPE_SETUP_BEGIN }),
  onboardingStripeSetupSuccess: (data) => ({ type: actions.ONBOARDING_STRIPE_SETUP_SUCCESS, data }),
  onboardingStripeSetupErr: (err) => ({ type: actions.ONBOARDING_STRIPE_SETUP_ERR, err }),

  onboardingStripeConfirmBegin: () => ({ type: actions.ONBOARDING_STRIPE_CONFIRM_BEGIN }),
  onboardingStripeConfirmSuccess: (data) => ({ type: actions.ONBOARDING_STRIPE_CONFIRM_SUCCESS, data }),
  onboardingStripeConfirmErr: (err) => ({ type: actions.ONBOARDING_STRIPE_CONFIRM_ERR, err }),

  onboardingAgreeDefaultsBegin:   () => ({ type: actions.ONBOARDING_AGREE_DEFAULTS_BEGIN }),
  onboardingAgreeDefaultsSuccess: (data) => ({ type: actions.ONBOARDING_AGREE_DEFAULTS_SUCCESS, data }),
  onboardingAgreeDefaultsErr:     (err) => ({ type: actions.ONBOARDING_AGREE_DEFAULTS_ERR, err }),

  onboardingPartnerCoverageBegin:   () => ({ type: actions.ONBOARDING_PARTNER_COVERAGE_BEGIN }),
  onboardingPartnerCoverageSuccess: (data) => ({ type: actions.ONBOARDING_PARTNER_COVERAGE_SUCCESS, data }),
  onboardingPartnerCoverageErr:     (err) => ({ type: actions.ONBOARDING_PARTNER_COVERAGE_ERR, err }),

  onboardingSyncProgressBegin:   () => ({ type: actions.ONBOARDING_SYNC_PROGRESS_BEGIN }),
  onboardingSyncProgressSuccess: (data) => ({ type: actions.ONBOARDING_SYNC_PROGRESS_SUCCESS, data }),
  onboardingSyncProgressErr:     (err) => ({ type: actions.ONBOARDING_SYNC_PROGRESS_ERR, err }),

  onboardingLocalFaveAddBegin:   () => ({ type: actions.ONBOARDING_LOCAL_FAVE_ADD_BEGIN }),
  onboardingLocalFaveAddSuccess: (data) => ({ type: actions.ONBOARDING_LOCAL_FAVE_ADD_SUCCESS, data }),
  onboardingLocalFaveAddErr:     (err) => ({ type: actions.ONBOARDING_LOCAL_FAVE_ADD_ERR, err }),

  onboardingLocalFaveUpdateBegin:   () => ({ type: actions.ONBOARDING_LOCAL_FAVE_UPDATE_BEGIN }),
  onboardingLocalFaveUpdateSuccess: (data) => ({ type: actions.ONBOARDING_LOCAL_FAVE_UPDATE_SUCCESS, data }),
  onboardingLocalFaveUpdateErr:     (err) => ({ type: actions.ONBOARDING_LOCAL_FAVE_UPDATE_ERR, err }),

  onboardingLocalFaveDeleteBegin:   () => ({ type: actions.ONBOARDING_LOCAL_FAVE_DELETE_BEGIN }),
  onboardingLocalFaveDeleteSuccess: (data) => ({ type: actions.ONBOARDING_LOCAL_FAVE_DELETE_SUCCESS, data }),
  onboardingLocalFaveDeleteErr:     (err) => ({ type: actions.ONBOARDING_LOCAL_FAVE_DELETE_ERR, err }),

  onboardingLocalFaveReorderBegin:   () => ({ type: actions.ONBOARDING_LOCAL_FAVE_REORDER_BEGIN }),
  onboardingLocalFaveReorderSuccess: (data) => ({ type: actions.ONBOARDING_LOCAL_FAVE_REORDER_SUCCESS, data }),
  onboardingLocalFaveReorderErr:     (err) => ({ type: actions.ONBOARDING_LOCAL_FAVE_REORDER_ERR, err }),

  onboardingGuidebookSectionSaveBegin:   () => ({ type: actions.ONBOARDING_GUIDEBOOK_SECTION_SAVE_BEGIN }),
  onboardingGuidebookSectionSaveSuccess: (data) => ({ type: actions.ONBOARDING_GUIDEBOOK_SECTION_SAVE_SUCCESS, data }),
  onboardingGuidebookSectionSaveErr:     (err) => ({ type: actions.ONBOARDING_GUIDEBOOK_SECTION_SAVE_ERR, err }),

  onboardingSetListingThemeBegin:   () => ({ type: actions.ONBOARDING_SET_LISTING_THEME_BEGIN }),
  onboardingSetListingThemeSuccess: (data) => ({ type: actions.ONBOARDING_SET_LISTING_THEME_SUCCESS, data }),
  onboardingSetListingThemeErr:     (err) => ({ type: actions.ONBOARDING_SET_LISTING_THEME_ERR, err }),

  onboardingTriggerListingSyncBegin:   () => ({ type: actions.ONBOARDING_TRIGGER_LISTING_SYNC_BEGIN }),
  onboardingTriggerListingSyncSuccess: (data) => ({ type: actions.ONBOARDING_TRIGGER_LISTING_SYNC_SUCCESS, data }),
  onboardingTriggerListingSyncErr:     (err) => ({ type: actions.ONBOARDING_TRIGGER_LISTING_SYNC_ERR, err }),

  onboardingGuidebookPreviewBegin:   () => ({ type: actions.ONBOARDING_GUIDEBOOK_PREVIEW_BEGIN }),
  onboardingGuidebookPreviewSuccess: (data) => ({ type: actions.ONBOARDING_GUIDEBOOK_PREVIEW_SUCCESS, data }),
  onboardingGuidebookPreviewErr:     (err) => ({ type: actions.ONBOARDING_GUIDEBOOK_PREVIEW_ERR, err }),

  onboardingThemesBegin:   () => ({ type: actions.ONBOARDING_THEMES_BEGIN }),
  onboardingThemesSuccess: (data) => ({ type: actions.ONBOARDING_THEMES_SUCCESS, data }),
  onboardingThemesErr:     (err) => ({ type: actions.ONBOARDING_THEMES_ERR, err }),

  onboardingUpdateMsgTemplateBegin:   () => ({ type: actions.ONBOARDING_UPDATE_MSG_TEMPLATE_BEGIN }),
  onboardingUpdateMsgTemplateSuccess: (data) => ({ type: actions.ONBOARDING_UPDATE_MSG_TEMPLATE_SUCCESS, data }),
  onboardingUpdateMsgTemplateErr:     (err) => ({ type: actions.ONBOARDING_UPDATE_MSG_TEMPLATE_ERR, err }),

  onboardingActivateMessagingBegin:   () => ({ type: actions.ONBOARDING_ACTIVATE_MESSAGING_BEGIN }),
  onboardingActivateMessagingSuccess: (data) => ({ type: actions.ONBOARDING_ACTIVATE_MESSAGING_SUCCESS, data }),
  onboardingActivateMessagingErr:     (err) => ({ type: actions.ONBOARDING_ACTIVATE_MESSAGING_ERR, err }),

  onboardingGuidebookStatusBegin:   () => ({ type: actions.ONBOARDING_GUIDEBOOK_STATUS_BEGIN }),
  onboardingGuidebookStatusSuccess: (data) => ({ type: actions.ONBOARDING_GUIDEBOOK_STATUS_SUCCESS, data }),
  onboardingGuidebookStatusErr:     (err) => ({ type: actions.ONBOARDING_GUIDEBOOK_STATUS_ERR, err }),

  onboardingPmsConnectionStatusBegin:   () => ({ type: actions.ONBOARDING_PMS_CONNECTION_STATUS_BEGIN }),
  onboardingPmsConnectionStatusSuccess: (data) => ({ type: actions.ONBOARDING_PMS_CONNECTION_STATUS_SUCCESS, data }),
  onboardingPmsConnectionStatusErr:     (err) => ({ type: actions.ONBOARDING_PMS_CONNECTION_STATUS_ERR, err }),

  onboardingConnectPmsCredentialsBegin:   () => ({ type: actions.ONBOARDING_CONNECT_PMS_CREDENTIALS_BEGIN }),
  onboardingConnectPmsCredentialsSuccess: (data) => ({ type: actions.ONBOARDING_CONNECT_PMS_CREDENTIALS_SUCCESS, data }),
  onboardingConnectPmsCredentialsErr:     (err) => ({ type: actions.ONBOARDING_CONNECT_PMS_CREDENTIALS_ERR, err }),

  onboardingIsUsHostBegin:   () => ({ type: actions.ONBOARDING_IS_US_HOST_BEGIN }),
  onboardingIsUsHostSuccess: (data) => ({ type: actions.ONBOARDING_IS_US_HOST_SUCCESS, data }),
  onboardingIsUsHostErr:     (err) => ({ type: actions.ONBOARDING_IS_US_HOST_ERR, err }),

  onboardingArrivalPrefBegin:   () => ({ type: actions.ONBOARDING_ARRIVAL_PREF_BEGIN }),
  onboardingArrivalPrefSuccess: (data) => ({ type: actions.ONBOARDING_ARRIVAL_PREF_SUCCESS, data }),
  onboardingArrivalPrefErr:     (err) => ({ type: actions.ONBOARDING_ARRIVAL_PREF_ERR, err }),

  onboardingTaskVerbiagesBegin:   () => ({ type: actions.ONBOARDING_TASK_VERBIAGES_BEGIN }),
  onboardingTaskVerbiagesSuccess: (data) => ({ type: actions.ONBOARDING_TASK_VERBIAGES_SUCCESS, data }),
  onboardingTaskVerbiagesErr:     (err) => ({ type: actions.ONBOARDING_TASK_VERBIAGES_ERR, err }),

  onboardingTaskCompleteAllBegin:   () => ({ type: actions.ONBOARDING_TASK_COMPLETE_ALL_BEGIN }),
  onboardingTaskCompleteAllSuccess: (data) => ({ type: actions.ONBOARDING_TASK_COMPLETE_ALL_SUCCESS, data }),
  onboardingTaskCompleteAllErr:     (err) => ({ type: actions.ONBOARDING_TASK_COMPLETE_ALL_ERR, err }),

  onboardingUpgradeToProBegin:   () => ({ type: actions.ONBOARDING_UPGRADE_TO_PRO_BEGIN }),
  onboardingUpgradeToProSuccess: (data) => ({ type: actions.ONBOARDING_UPGRADE_TO_PRO_SUCCESS, data }),
  onboardingUpgradeToProErr:     (err) => ({ type: actions.ONBOARDING_UPGRADE_TO_PRO_ERR, err }),

  onboardingSetStepDraft: (slug, data) => ({ type: actions.ONBOARDING_SET_STEP_DRAFT, slug, data }),

  onboardingCmsSet: (data) => ({ type: actions.ONBOARDING_CMS_SET, data }),

  onboardingLogsBegin:   () => ({ type: actions.ONBOARDING_LOGS_BEGIN }),
  onboardingLogsSuccess: (data) => ({ type: actions.ONBOARDING_LOGS_SUCCESS, data }),
  onboardingLogsErr:     (err) => ({ type: actions.ONBOARDING_LOGS_ERR, err }),

  onboardingClientLogBegin:   () => ({ type: actions.ONBOARDING_CLIENT_LOG_BEGIN }),
  onboardingClientLogSuccess: (data) => ({ type: actions.ONBOARDING_CLIENT_LOG_SUCCESS, data }),
  onboardingClientLogErr:     (err) => ({ type: actions.ONBOARDING_CLIENT_LOG_ERR, err }),
};

export default actions;
